import { render, staticRenderFns } from "./Tab1.vue?vue&type=template&id=1b30ec1e&scoped=true&"
import script from "./Tab1.vue?vue&type=script&lang=ts&"
export * from "./Tab1.vue?vue&type=script&lang=ts&"
import style0 from "./Tab1.vue?vue&type=style&index=0&id=1b30ec1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b30ec1e",
  null
  
)

export default component.exports